export default "__VITE_ASSET__D$gp9ufK__"